import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import { getLangProperty } from '@appbase/util';


interface linkObj {
    param: string,
    type: string,
    linkName: string
}

@Component({
})

export default class OpenWindowField extends Vue {
    @Prop ({ type: Object }) context!: board.ContentField;
    @PropSync('returnValue', { type: String }) textModel!: string;
    @Prop({ type: Object }) initOptions!: any;


    includeLink:boolean = true
    moveTo:string = ""

    created() {
        if (this.initOptions && this.initOptions.TextField) {
            var options = this.initOptions.TextField;
        }
        if(this.textModel.includes('https'))
            this.moveTo = this.textModel
        else{
            this.includeLink = false;
            const host = window.location.origin;
            let link = ""
            let obj:linkObj|null;
            try{
                obj = JSON.parse(this.textModel);
            }
            catch{
                obj =null;
            }
            if(obj && obj.type=='wf'){
                link = `${host}/workflow/page/form?${obj.param}&storekey=${new Date().getTime()}`
            }
            this.moveTo = link;
        }
    }

    get displayName() {
        return getLangProperty(this.context, 'displayName');
    }
}